import {get, post} from 'utils/axios/index'
import {toast} from 'react-toastify'
import ApiResponse, {
 DefaultApiResponse,
} from 'models/ApiResponse'
import {AxiosError} from 'axios'
import {
 handleRejectedErrorMsg,
 showErrorMsg,
} from 'utils/helpers/handleError'
import IDropdownVal from 'models/dropdown'
import {IOnboardingItems} from 'models/GenericForm'
import {IFormField} from 'models/Common'

const fetchStackholders = async (
 tab?: string,
 user_id?: string
) => {
 try {
  return await get<ApiResponse<IDropdownVal>>(
   '/rb/v1/stakeholders',
   {
    ...(tab && {tab}),
    ...(user_id && {user_id}),
   }
  ).then((res) => {
   if (res.success) {
    return res.data
   } else {
    toast.error(res.message)
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return []
 }
}

const fetchStackholderCategory = async (
 stakeholder?: number,
 tab?: string,
 user_id?: string
) => {
 try {
  return await get<ApiResponse<IDropdownVal>>(
   '/rb/v1/categories',
   {
    ...(stakeholder && {stakeholder}),
    ...(tab && {tab}),
    ...(user_id && {user_id}),
   }
  ).then((res) => {
   if (res.success) {
    return res.data
   } else {
    toast.error(res.message)
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return []
 }
}

const fetchUserCategory = async (
 stakeholder: number,
 category: number
) => {
 try {
  return await get<ApiResponse<IDropdownVal>>(
   '/rb/v1/user-category',
   {
    stakeholder,
    category,
   }
  ).then((res) => {
   if (res.success) {
    return res.data
   } else {
    toast.error(res.message)
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return []
 }
}

const fetchOnboardingItmesConfig = async (
 userCategory: number,
 parentConfigId: number
) => {
 try {
  return await (
   await get
  )<DefaultApiResponse>(
   '/rb-platform/v1/onboarding-itmes-config',
   {
    user_category: userCategory,
    ...(parentConfigId && {
     parent_onboarding_item: parentConfigId,
    }),
   }
  ).then((res) => {
   if (res.success) {
    return res.data
   } else {
    toast.error(res.message)
    return []
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return []
 }
}

const submitOnboardingItmes = async (
 data: IOnboardingItems
) => {
 try {
  const res = await post<DefaultApiResponse>(
   '/rb-platform/v1/user-onboarding',
   {data}
  )
  if (res.success) {
   return res.data
  } else {
   showErrorMsg(res.message)
   return null
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
 } catch (err: any) {
  const e = err as AxiosError
  // eslint-disable-next-line no-console
  console.log('err', e.response?.data)
  handleRejectedErrorMsg(e)
  return null
 }
}

const generateOTP = async (payload: IFormField) => {
 try {
  const res = await post<DefaultApiResponse>(
   '/common/v1/send-otp',
   payload
  )
  if (res.success) {
   return res?.message
  } else {
   showErrorMsg(res.message)
   return null
  }
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

const verifyOTP = async (payload: IFormField) => {
 try {
  const res = await post<DefaultApiResponse>(
   '/common/v1/verify-otp',
   payload
  )
  if (res.success) {
   return res?.message
  } else {
   showErrorMsg(res.message)
   return null
  }
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

export {
 fetchStackholders,
 fetchStackholderCategory,
 fetchUserCategory,
 fetchOnboardingItmesConfig,
 submitOnboardingItmes,
 generateOTP,
 verifyOTP,
}
